// eslint-disable-next-line import/extensions
import fa from './fa'
// eslint-disable-next-line import/extensions
import en from './en'
// eslint-disable-next-line import/extensions
import ar from './ar'

export default {
  fa,
  en,
  ar,
}
